import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../common';

import { DpsCommonModule } from '../../dataprotection-common/dataprotection-common.module';
import { DpsOpsCommonModule } from '../common-ops/common-ops.component';
import DPSDeletedVmVc from './deleted-vms.component';
import { ResizableModule } from 'angular-resizable-element';

@NgModule({
    declarations: [
        DPSDeletedVmVc
    ],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule.forRoot(),
        DpsCommonModule,
        DpsOpsCommonModule,
        ResizableModule
    ],
    providers: [
    ],
    exports: [
        DPSDeletedVmVc
    ]

})
export class DpsDeletedVmsModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/deleted-vms/deleted-vms.module.ts